/* eslint-disable */
import { Button, TextField, Dialog, MenuItem, Box } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import ArrowDownIcon from "../../../components/icons/arrow/ArrowDownIcon";
import { usePermissionStore } from "../../../stores/permissionStore";
import Text from "../../../components/atoms/Text";
import useSubmit from "./useSubmit";
import { actionType } from "./constants";

const AddPointsDialog = ({
  dataActivityTypes,
  isShow,
  omneId,
  userRewardId,
  userRedemptionId,
  mode,
  points,
  activityTypeName,
  rewardTypeName,
  activityTypeId,
  handleClose,
  dateTime,
}) => {
  const [_activityTypeId, setActivityTypeId] = useState(activityTypeId ?? "");
  const [inputPoints, setInputPoints] = useState(points ?? "");
  const [remark, setRemark] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);

  const resetData = () => {
    setActivityTypeId("");
    setInputPoints("");
    setRemark("");
    setDisableSubmit(false);
  };

  const { handleSubmitOnAddPointsDialog: handleSubmit } = useSubmit({
    omneId,
    userRewardId,
    activityTypeId: _activityTypeId,
    userRedemptionId,
    points: inputPoints,
    remark,
    mode,
    handleClose,
    resetData,
    setDisableSubmit,
    permission_Token: usePermissionStore.getState().permissionToken ?? "",
  });

  const handleChange = e => {
    setActivityTypeId(e.target.value);
  };
  const handleInputPoints = e => setInputPoints(e.target.value);
  const handleInputRemark = e => setRemark(e.target.value);

  const renderCategoryDDL = () => {
    if (mode === actionType.ADD) {
      return (
        <TextField
          select
          label="Category"
          style={{ marginBottom: 20 }}
          onChange={handleChange}
          SelectProps={{
            IconComponent: props => (
              <Box {...props}>
                <ArrowDownIcon />
              </Box>
            ),
          }}
        >
          {dataActivityTypes?.data?.map?.(option => (
            <MenuItem key={option.id} value={option.id}>
              {option.id}__{option.activityTypeName}
            </MenuItem>
          ))}
        </TextField>
      );
    }
  };

  const renderTitle = () => {
    switch (mode) {
      case actionType.ADD:
        return "Add Points - Create";
      case actionType.EDIT:
        return "Add Points - Edit";
      case actionType.REFUND:
        return "Add Points - Refund";
    }
  };

  return (
    <>
      <Dialog open={isShow} onClose={handleClose}>
        <div style={{ padding: 50 }}>
          <Text variant="h3" style={{ paddingBottom: 20 }}>
            {renderTitle()}
          </Text>
          {[actionType.EDIT, actionType.REFUND].includes(mode) && (
            <>
              <Text>ID: {userRedemptionId || userRewardId}</Text>
              <br />
              <Text>
                Date/Time: {dateTime && dayjs(dateTime).format("DD/MM/YYYY")}
              </Text>
              <br />
              {mode === actionType.REFUND && (
                <>
                  <Text>Points: {points}</Text>
                  <br />
                </>
              )}

              <Text>Category: {activityTypeName}</Text>
              <br />
              <Text>Item name: {rewardTypeName}</Text>
              <br />
            </>
          )}
          {renderCategoryDDL()}
          {[actionType.ADD, actionType.EDIT].includes(mode) && (
            <TextField
              label="Points"
              style={{ marginBottom: 20 }}
              defaultValue={points}
              value={inputPoints}
              onChange={e => {
                const reg = /^[0-9]+$/;
                if (e.target.value) {
                  if (reg.test(e.target.value)) {
                    setInputPoints(e.target.value);
                  } else {
                    setInputPoints(inputPoints);
                  }
                } else {
                  setInputPoints("");
                }
              }}
            />
          )}
          {[actionType.ADD, actionType.REFUND].includes(mode) && (
            <TextField label="Remarks" onBlur={handleInputRemark} />
          )}
        </div>
        <Button
          disabled={disableSubmit}
          onClick={handleSubmit}
          style={{ borderRadius: 0, paddingTop: 10, paddingBottom: 10 }}
        >
          Confirm
        </Button>
      </Dialog>
    </>
  );
};

export default AddPointsDialog;
